import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { validateToken, resetPassword } from "./authService";
import MainHeader from "../pages/MainHeader";
import { useNavigate } from "react-router-dom";
import { routes } from "../routes/routes-names";

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (token) {
      validateToken(token).catch(() => {
        setError("Invalid or expired reset link");
      });
    }
  }, [token]);

  const handleReset = async () => {
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      await resetPassword(token!, password);
      setMessage("Password reset successfully. Please login.");
    } catch (err: any) {
      setError(err.response?.data || "Reset failed");
    }
  };

  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div >
      <MainHeader/>
      
      
      <div className="container-fluid  pt-5 d-flex align-items-center justify-content-center">
        <div className="grid-container">
      <h2 className="cme-title">Reset Password</h2>
      <div className="field-item">
      <input
        type="password"
        minLength={6}
        placeholder="New Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
</div>
<div className="field-item pt-3">
      <input
        type="password"
        minLength={6}
        placeholder="Confirm Password"
        value={confirmPassword}
        
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
</div>
<div className="field-item pt-3">
      <button onClick={handleReset}>Reset Password</button>
      </div>

      {message && <div> <p style={{ color: "green" }}>{message}</p>
      <button type="button"  onClick={() => { navigate(routes.main); }} className="fw-semibold">Back to Login</button>
        
        </div>
        }
      
      </div>
      
</div>
      </div>
      

  );
};

export default ResetPassword;
